/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Link } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { debounce } from 'lodash';

import Input from '../../../components/Input';
import api from '../../../services/api';

import Button from '../../../components/Button';
import { Main, SearchIcon, Section } from './styles';

interface IClientFormData {
  client: {
    clientList: {
      id: string;
      name: string;
      userType: string;
      status: string;
    };
  };
}

const Clientes: React.FC = () => {
  const formRefSearch = useRef<FormHandles>(null);
  const [search, setSearch] = useState('');
  const [dataSearch, setDataSearch] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [clients, setClients] = useState<any>();

  const fetchClients = async () => {
    try {
      setLoading(true);
      const response = await api.get<IClientFormData>('/client/all');
      setClients(response.data.client.clientList!);
      setDataSearch(response.data.client.clientList!);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const didMount = () => {
    fetchClients();
  };
  useEffect(didMount, []);

  const debouncedData = useCallback(
    debounce(() => {
      if (search !== '') {
        const mySearch = clients.filter((c: { name: string }) =>
          c.name.toLowerCase().includes(search.toLocaleLowerCase()),
        );
        if (search.length) {
          setDataSearch(mySearch);
        }
      } else {
        setDataSearch(clients);
      }
    }, 500),
    [clients, search],
  );

  useEffect(() => {
    debouncedData();
  }, [search, didMount]);

  return (
    <>
      <Main>
        <div className="header-main">
          <div>
            <h1>Acompanhe o cadastro de seus clientes</h1>
          </div>
          <Link to="/novo-pedido">
            <Button type="button">+ Novo Pedido</Button>
          </Link>
        </div>
        <Section>
          <div className="sectionCard">
            <h2>Cadastro de Clientes</h2>
            <div className="flex-container">
              <div className="menu-cadastro">
                <div className="item-cadastrados">Clientes Cadastrados</div>
                <Link to="/cadastro-cliente">
                  <div className="item-novo-cadastro">Novo Cadastro</div>
                </Link>
              </div>
              <Form ref={formRefSearch} onSubmit={() => {}}>
                <div className="searchBar">
                  <SearchIcon />
                  <Input
                    name="search"
                    type="text"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    placeholder="Procure o cliente por nome"
                  />
                </div>
              </Form>
              <div>
                <div className="list-clientes">
                  <div>
                    {!loading &&
                      dataSearch?.map((c: any) => (
                        <div key={c.id}>
                          <div className="client-item">
                            <div>
                              <h4>{c.name}</h4>
                            </div>
                            <div className="bottomPedidos">
                              <Link to={`/editar-cliente/${c.id}`}>
                                <Button className="allItems">
                                  Editar Cadastro
                                </Button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))}
                    {clients?.length === 0 && (
                      <h4>Você não possui Clientes cadastrados...</h4>
                    )}
                    {loading && (
                      <div className="loadingData">
                        <span>Carregando...</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>
      </Main>
    </>
  );
};

export default Clientes;
